import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../mock";

const CTABanner = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  return (
    <div style={{ padding: "30px 0 30px" }}>
      <div className="cta-banner grain">
        <h2>Reveal the Secrets of Your Future with<br/>{CONTACT.name}</h2>
        <p>Trusted by 82,000+ clients across Bangalore and beyond. Your path to clarity begins with one call.</p>
        <div className="cta-actions">
          <a href={`tel:${CONTACT.callNumber}`} className="btn btn-call"><Phone size={16} /> Call Now: {CONTACT.callDisplay}</a>
          <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="btn btn-wa"><MessageCircle size={16} /> WhatsApp Guruji</a>
        </div>
      </div>
    </div>
  );
};

export default CTABanner;
